import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtitle?: string;
  href?: string;
  scrollTo?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  text,
  subtitle,
  href = '#registro',
  scrollTo,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (scrollTo) {
      e.preventDefault();
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <motion.a href={scrollTo ? `#${scrollTo}` : href} onClick={handleClick} className={`group relative inline-flex flex-col items-center justify-center rounded-xl bg-orange-600 px-8 py-4 font-bold text-white shadow-lg transition-all hover:bg-orange-500 hover:shadow-orange-500/25 ${fullWidth ? 'w-full' : 'w-auto'} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} data-id="element-1">
      {/* Pulse effect */}
      <span className="absolute inset-0 -z-10 animate-pulse rounded-xl bg-orange-600/50 blur-lg" data-id="element-2" />

      <div className="flex items-center gap-2 text-lg md:text-xl uppercase tracking-wide" data-id="element-3">
        {text}
        <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-4" />
      </div>

      {subtitle && <span className="mt-1 text-xs md:text-sm font-medium text-orange-100 opacity-90" data-id="element-5">
          {subtitle}
        </span>}
    </motion.a>;
}